import { ICaptionsItem } from '../../types/common';
import { TConferenceSaveLevel } from '../../../common/rest/conference/conferenceSaveLevel';

export const CALL_STATE_LOCAL_STORAGE = 'CALL_STATE';
export const CALL_UPDATE_ACTION = 'CALL/CALL_UPDATE_ACTION';

export interface ICallUpdateAction {
	type: typeof CALL_UPDATE_ACTION;
	call: Partial<ICallState>;
}

// Shown on the home page in place of the new-call form until dismissed:
// finished — a link to a call that is over; ended/endedNothing — this client's call just ended; notFound — no such room.
export type TCallNotice = 'finished' | 'ended' | 'endedNothing' | 'notFound';

export interface ICallState {
	isActive?: boolean;
	lang?: string; // todo no need?
	multilingual?: boolean;
	roomId?: string;
	token?: string;
	notice?: TCallNotice | null;
	// Bootstrap value for CallProvider's saveLevel (LNG-1710), from create/join.
	saveLevel?: TConferenceSaveLevel;
	// Call start in this client's clock (server time shifted by the measured skew), ms.
	startedAt?: number;
}

export type ICallAction =
	| ICallUpdateAction
